/* Keep DOM/date order, placing each article in the shortest available column. */
if (!customElements.get('blog-masonry')) {
  customElements.define('blog-masonry', class extends HTMLElement {
    connectedCallback() {
      if (this.classList.contains('blog-articles--collage')) return;
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.layout());
      };
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.observedItems = new Set();
      this.resizeObserver.observe(this);
      this.mutationObserver = new MutationObserver(this.schedule);
      this.mutationObserver.observe(this, { childList: true });
      this.addEventListener('load', this.schedule, true);
      window.addEventListener('resize', this.schedule);
      document.fonts.ready.then(() => { if (this.isConnected) this.schedule(); });
      this.schedule();
    }

    layout() {
      const availableWidth = this.clientWidth;
      if (!availableWidth) return;
      const styles = getComputedStyle(this);
      const columns = Number(styles.getPropertyValue('--blog-columns')) || 2;
      const gap = parseFloat(styles.columnGap) || 12;
      const verticalGap = parseFloat(styles.getPropertyValue('--blog-card-gap')) || 24;
      const width = (availableWidth - gap * (columns - 1)) / columns;
      const items = Array.from(this.children);
      for (const item of this.observedItems) {
        if (!items.includes(item)) {
          this.resizeObserver.unobserve(item);
          this.observedItems.delete(item);
        }
      }
      this.classList.add('masonry-ready');
      items.forEach(item => { item.style.width = `${width}px`; });
      const heights = items.map(item => item.getBoundingClientRect().height);
      const bottoms = Array(columns).fill(0);
      const rtl = styles.direction === 'rtl';
      items.forEach((item, index) => {
        const column = bottoms.indexOf(Math.min(...bottoms));
        item.style.left = `${(rtl ? columns - 1 - column : column) * (width + gap)}px`;
        item.style.top = `${bottoms[column]}px`;
        bottoms[column] += heights[index] + verticalGap;
        if (!this.observedItems.has(item)) {
          this.resizeObserver.observe(item);
          this.observedItems.add(item);
        }
      });
      const height = items.length ? Math.max(...bottoms) - verticalGap : 0;
      this.style.height = `${height}px`;
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
      this.removeEventListener('load', this.schedule, true);
      window.removeEventListener('resize', this.schedule);
    }
  });
}
